export default {"src":"/_next/static/media/redesign.96a425d5.svg","height":1650,"width":2475,"blurWidth":0,"blurHeight":0};